import Store from '../store/index'
import Rpc from '../config/apiServer/chain33rpc'
import { ElMessage } from 'element-plus'
import router from '@/router/index'

export async function search(value: any, callback: () => void): Promise<void> {
  const maxHeight = Store.state.maxHeight
  const reg = /^[0-9]*[1-9][0-9]*$/;
  value = value.trim()
  if (!value) {
    ElMessage.info('请输入哈希/区块哈希/地址/区块高度')
    Store.setShowToast(false)
    return
  }
  Store.setShowToast(true)
  // 搜索区块
  try {
    if (reg.test(value) || Number(value) == 0) {
      if (Number(value) > maxHeight) {
        ElMessage.warning('输入的高度不能超过最大高度!')
        Store.setShowToast(false)
        return
      }
      await Rpc.getBlockHash(Number(value)).then(data => {
        if (data.error == null) {
          router.push({
            path: "/blockDetail",
            query: {
              height: value
            }
          })
        } else ElMessage.warning('输入信息有误，请重新输入')
      })
    } else {
      const e = value.length
      // 交易哈希
      if (e == 66 || e == 64) {
        value = e == 64 ? '0x' + value : value
        await Rpc.queryTransaction(value).then(async data => {
          if (data.error == null) {
            router.push({
              path: "/tradeHash",
              query: {
                hash: value
              }
            });
          } else {
            await Rpc.getBlockOverview(value).then(res => {
              if (res.error == null) {
                router.push({
                  path: "/blockDetail",
                  query: {
                    height: res.result.head.height
                  }
                });
              } else ElMessage.warning('输入信息有误，请重新输入')
            })
          }
        })
      } else {
        // 地址
        await Rpc.getAddrOverview(value).then(data => {
          if (data.error == null) {
            router.push({
              path: "/address",
              query: {
                address: value,
                way: 0
              }
            });
          } else ElMessage.warning('输入信息有误，请重新输入')
        })
      }
    }
  } catch (e) {
    ElMessage.warning(e as Error)
    Store.setShowToast(false)
  }
  Store.setShowToast(false)
  callback()
}